import React, { useContext } from 'react';
import classNames from 'classnames';
import { MenuItem } from '@/api/cms/mapMenuTree';
import { Link } from '@/components/shared';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetTranslations } from '@/generated/translations';
import styles from './Menu.module.scss';

interface MenuProps {
	menuColClassName: string;
	menu: MenuItem[];
}

export const Menu: React.FunctionComponent<MenuProps> = ({ menuColClassName, menu }) => {
	const { segmentationId } = useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);

	return (
		<>
			{menu.map((item) => {
				return (
					<ul className={menuColClassName} key={item.id}>
						<li>
							<p className={classNames(styles.menuListTitle, 'u-group-title')}>{item.title}</p>

							{item.externalLink || item.internalLink ? (
								<Link linkUrl={item.externalLink} to={item.internalLink} textLink>
									{translations?.data.mobileMenu.showAll}
								</Link>
							) : null}

							{item.children && (
								<ul className={'u-mt-md'}>
									{item.children.map((child) => (
										<li className={styles.childItem} key={child.title}>
											<Link linkUrl={child.externalLink} to={child.internalLink} textLink>
												{child.title}
											</Link>
										</li>
									))}
								</ul>
							)}
						</li>
					</ul>
				);
			})}
		</>
	);
};
